
  <mat-card class="slidecontent">
    <div class="headcontent">
    
        <div class="pophead">
            <h3>Send Document</h3>
              <mat-icon  class="close" (click)="closeShareOpt(closeShare)">close</mat-icon>
          </div>
        </div>
          <div class="dialog_content">

            <div class="documentListing">

              <ng-container *ngFor="let document of selectedFileList; let i = index">

              <div class="doc placeholder" *ngIf="!document.fileType">   
                <span class="type"> <mat-icon>backup</mat-icon> </span>
                <div class="name">
                  {{ getplaceholdername(document.name) }}
                </div>
                <button class="remove" mat-icon-button (click)="removeDocument(document)"><mat-icon>cancel</mat-icon></button>
              </div>

              <div class="doc" *ngIf="document.fileType">
                <span class="type" *ngIf="document.fileType == 'pdf' || document.fileType == '.pdf'">
                  <img src="../../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" />
                 </span>

                <span class="type" *ngIf="document.fileType == 'doc' ||
                    document.fileType == 'docx'">
                    <img src="../../../../../assets/icons/fileType/doc_icon.svg" alt="Word File"/>
                 </span>

                <span class="type" *ngIf="document.fileType == 'xlsx' ||
                    document.fileType == 'xls' ||
                    document.fileType == 'csv' ||
                    document.fileType == 'ods'">
                  <img src="../../../../../assets/icons/fileType/excel_icon.svg" alt="excel File"/>
                </span>
                <span class="type" *ngIf="document.fileType == 'jpg' ||
                    document.fileType == 'jpeg' || 
                    document.fileType == 'image/jpeg'">
                    <img src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File"/>
                  </span>
                <span class="type" *ngIf="document.fileType == 'png' ||
                    document.fileType == 'gif' ||
                    document.fileType == 'tiff' ||
                    document.fileType == 'webp' ||
                    document.fileType == 'bmp'">
                    <img src="../../../../../assets/icons/fileType/020-png.svg" alt="png File"/>
                  </span>
                <span class="type" *ngIf="document.fileType == 'txt'">
                  <img src="../../../../../assets/icons/fileType/text_icon.svg" alt="txt File"/>
                  </span>
                <span class="type" *ngIf="document.fileType == 'ppt' ||
                    document.fileType == 'pptx'">
                    <img src="../../../../../assets/icons/fileType/021-ppt.svg" alt="ppt File"/>
                  </span>               
                <div class="name">
                  {{ getplaceholdername(document.name) }}
                </div>
                <button class="remove" mat-icon-button (click)="removeDocument(document)"><mat-icon>cancel</mat-icon></button>
              </div>
              </ng-container>

             
            </div>


            <ng-container>
              <div class="reminder">
                <div class="remind">                 
                </div>
    
                <ng-container >           
                  <div class="block mt-10">
                    <mat-radio-group aria-label="Select an option" color="primary" (change)="selectCCC($event)">
                      <mat-radio-button value="Core" [checked]="checkedAttachCore">{{CoreShowName}}</mat-radio-button>
                      <mat-radio-button value="Contact" [checked]="checkedAttachContact">{{ContactShowName}}</mat-radio-button>
                      <mat-radio-button value="Company" [checked]="checkedAttachCompany">{{CompanyShowName}}</mat-radio-button>
                    </mat-radio-group>
                  </div>
    
    
                  <div class="block mt-10" *ngIf="ShowAttchedToCore">
                    <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
                      <mat-label>Search {{CoreShowName}}</mat-label>
                      <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                        (input)="searchCore($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
                      <mat-autocomplete #auto="matAutocomplete">
                        <mat-option (click)="attchedToCoreSelected(core)" *ngFor="let core of attachedToCoreList"
                          [value]="core.name">
                          <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                            <div class="userpic">
                              <img *ngIf="core.imageUrl!='' " src="{{core.imageUrl}}" alt="">
                              <span class="username" *ngIf="core.imageUrl==''" class="username">
                                {{core.shortName}}
                              </span>
                            </div>
                            <div class="info">
                              <p> {{ core.name }}</p>
                              <p class="email">{{ core.email }}</p>
                            </div>
                          </span>
                        </mat-option>
                      </mat-autocomplete>
    
                    </mat-form-field>
                    <ul class="selectedlist" *ngFor="let core of attachedToSelectedCore">
                      <li>
                        <div class="userndetail">
                          <div class="userpic">
                            <img *ngIf="core.img!=''" src="{{core.img}}" alt="">
                            <span *ngIf="core.img==''" class="username">
                              {{core.shortName}}
                            </span>
                          </div>
                          <div class="details">
                            <h4>{{core.name}}</h4>
                            <p>{{core.email}}</p>
                          </div>
                          <div class="opt">
                            <button mat-icon-button>
                              <mat-icon (click)="attchedToRemoveCore(core)">cancel</mat-icon>
                            </button>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
    
                  <div class="block mt-10" *ngIf="ShowAttchedToContact">
                    <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
                      <mat-label>Search {{ContactShowName}}</mat-label>
                      <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                        (input)="searchContacts($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
                      <mat-autocomplete #auto="matAutocomplete">
                        <mat-option (click)="attchedToContactSelected(contact)"
                          *ngFor="let contact of attachedToContactList" [value]="contact.name">
                          <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                            <div class="userpic">
                              <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="">
                              <span class="username" *ngIf="contact.imageUrl==''" class="username">
                                {{contact.shortName}}
                              </span>
                            </div>
                            <div class="info">
                              <p> {{ contact.name }}</p>
                              <p class="email">{{ contact.email }}</p>
                            </div>
                          </span>
                        </mat-option>
                      </mat-autocomplete>
    
                    </mat-form-field>
                    <ul class="selectedlist" *ngFor="let contact of attachedToSelectedContact">
                      <li *ngIf="!contact.isDeleted">
                        <div class="userndetail">
                          <div class="userpic">
                            <img *ngIf="contact.img!=''" src="{{contact.img}}" alt="">
                            <span *ngIf="contact.img==''" class="username">
                              {{contact.shortName}}
                            </span>
                          </div>
                          <div class="details">
                            <h4>{{contact.name}}</h4>
                            <p>{{contact.email}}</p>
                          </div>
                          <div class="opt">
                            <button mat-icon-button>
                              <mat-icon (click)="attchedToRemoveContact(contact)">cancel</mat-icon>
                            </button>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
    
                  <div class="block mt-10" *ngIf="ShowAttchedToCompany">
                    <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
                      <mat-label>Search {{CompanyShowName}}</mat-label>
                      <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                        (input)="searchCompany($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
                      <mat-autocomplete #auto="matAutocomplete">
                        <mat-option (click)="attchedToCompanySelected(company)"
                          *ngFor="let company of attachedToCompanyList" [value]="company.name">
                          <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                            <div class="userpic">
                              <img *ngIf="company.imageUrl!=''" src="{{company.imageUrl}}" alt="">
                              <span class="username" *ngIf="company.imageUrl==''" class="username">
                                {{company.shortName}}
                              </span>
                            </div>
                            <div class="info">
                              <p> {{ company.name }}</p>
                              <p class="email">{{ company.email }}</p>
                            </div>
                          </span>
                        </mat-option>
                      </mat-autocomplete>
    
                    </mat-form-field>
                    <ul class="selectedlist" *ngFor="let company of attachedToSelectedCompany">
                      <li *ngIf="!company.isDeleted">
                        <div class="userndetail">
                          <div class="userpic">
                            <img *ngIf="company.img!=''" src="{{company.img}}" alt="">
                            <span *ngIf="company.img==''" class="username">
                              {{company.shortName}}
                            </span>
                          </div>
                          <div class="details">
                            <h4>{{company.name}}</h4>
                            <p>{{company.email}}</p>
                          </div>
                          <div class="opt">
                            <button mat-icon-button>
                              <mat-icon (click)="attchedToRemoveCompany(company)">cancel</mat-icon>
                            </button>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                 
                
                </ng-container>
    
              </div>
            </ng-container>
           
          </div>
   
    
    <div class="actionBtn"> 
    <button mat-flat-button class="cancel" (click)="cancelShareOpt(closeShare)">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary"
    [disabled]="!showAddButton" (click)="sendDocument()">Send
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
    </div>

</mat-card>




<div class="overlay" (click)="closeShareOpt(closeShare)"></div>


